export const LANDING = {
  // Nav
  navLogo: "nav-logo",
  navBuy: "nav-buy-btn",
  navMenuBundle: "nav-link-bundle",
  navMenuValue: "nav-link-value",
  navMenuFaq: "nav-link-faq",

  // Hero
  heroPrimaryCta: "hero-cta-buy",

  // Value stack
  valueCta: "value-cta-buy",

  // FAQ items
  faqItem: (i) => `faq-item-${i}`,

  // Final CTA
  finalCta: "final-cta-buy",

  // Checkout page
  checkoutEmailInput: "checkout-email-input",
  checkoutSubmit: "checkout-submit-btn",
  checkoutBack: "checkout-back-link",
  checkoutTotal: "checkout-total",

  // Thank-you page
  thanksTitle: "thanks-title",
  thanksDownload: (id) => `thanks-download-${id}`,

  // Footer
  footerLinkTerms: "footer-link-terms",
  footerLinkPrivacy: "footer-link-privacy",
  footerLinkContact: "footer-link-contact",
};
